<template>
  <span
    :class="
      {
        [PAYMENT_REQUEST_STATUS.declined]: 'bg-error',
        [PAYMENT_REQUEST_STATUS.cancelledProvider]:
          'bg-error',
        [PAYMENT_REQUEST_STATUS.cancelledClient]:
          'bg-error',
        [PAYMENT_REQUEST_STATUS.requested]: 'bg-info',
        [PAYMENT_REQUEST_STATUS.paid]: 'bg-positive',
        [PAYMENT_REQUEST_STATUS.refundedProvider]:
          'bg-warning',
      }[status]
    "
    class="rounded-full px-2 text-sm text-background"
  >
    {{ statusText }}
  </span>
</template>

<script setup lang="ts">
import {
  type PaymentRequestStatus,
  PAYMENT_REQUEST_STATUS,
} from "@/services/paymentRequests/paymentRequest"

const props = defineProps<{
  status: PaymentRequestStatus
}>()

const statusText = computed(
  () =>
    ({
      [PAYMENT_REQUEST_STATUS.declined]: "declined",
      [PAYMENT_REQUEST_STATUS.cancelledProvider]:
        "cancelled",
      [PAYMENT_REQUEST_STATUS.cancelledClient]: "cancelled",
      [PAYMENT_REQUEST_STATUS.requested]: "requested",
      [PAYMENT_REQUEST_STATUS.paid]: "paid",
      [PAYMENT_REQUEST_STATUS.refundedProvider]: "refunded",
    })[props.status]
)
</script>
